import React from 'react';
import { Icon } from './Icon.js';
export const IconLaptop = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 13L21 3L3 3L3 13", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M23 21L23 17L17 17L16.2929 17.7071C16.1054 17.8946 15.851 18 15.5858 18L8.41421 18C8.149 18 7.89464 17.8946 7.70711 17.7071L7 17L1 17L1 21L23 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconLaptop.js.map